import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/BodyComp"
import { invokeSetAddBodyCompAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/HeartAndBloodForm.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class HeartAndBloodForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            userFormData: {}
        }

       this.setUserFormData = this.setUserFormData.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getBodyCompAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var height                      = results.data[0].height;
                var weight                      = results.data[0].weight
                var lean_tissue_mass_percent    = results.data[0].lean_tissue_mass_percent
                var lean_tissue_mass_weight     = results.data[0].lean_tissue_mass_weight
                var adipose_tissue_mass_percent = results.data[0].adipose_tissue_mass_percent;
                var adipose_tissue_mass_weight  = results.data[0].adipose_tissue_mass_weight;
                var bmi                         = results.data[0].bmi;

                this.setState({
                    userFormData: {
                        height:                      height,
                        weight:                      weight,
                        lean_tissue_mass_percent:    lean_tissue_mass_percent,
                        lean_tissue_mass_weight:     lean_tissue_mass_weight,
                        adipose_tissue_mass_percent: adipose_tissue_mass_percent,
                        adipose_tissue_mass_weight:  adipose_tissue_mass_weight,
                        bmi:                         bmi
                    }
                });
            }
        } else {
            this.setUserFormData("", "", "", "", "", "", "");
        }
    }

    setUserFormData(height, weight, lean_tissue_mass_percent, lean_tissue_mass_weight,adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi) {
        this.setState({
            userFormData: {
                height:                      height,
                weight:                      weight,
                lean_tissue_mass_percent:    lean_tissue_mass_percent,
                lean_tissue_mass_weight:     lean_tissue_mass_weight,
                adipose_tissue_mass_percent: adipose_tissue_mass_percent,
                adipose_tissue_mass_weight:  adipose_tissue_mass_weight,
                bmi:                         bmi
            }
        });
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    onSubmit = async (formData) => {
        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 11; // heart and blood is #11 in dropdown

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var obj = this.getObjectData(formData);

        var height                      = obj.height;
        var weight                      = obj.weight;
        var lean_tissue_mass_percent    = obj.lean_tissue_mass_percent;
        var lean_tissue_mass_weight     = obj.lean_tissue_mass_weight;
        var adipose_tissue_mass_percent = obj.adipose_tissue_mass_percent;
        var adipose_tissue_mass_weight  = obj.adipose_tissue_mass_weight;
        var bmi                         = obj.bmi;

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddBodyCompAssessment(action, assessment_id, client_id, height, weight, lean_tissue_mass_percent, lean_tissue_mass_weight, adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }


    getObjectData = (formData) => {
        var height;
        var weight;
        var lean_tissue_mass_percent
        var lean_tissue_mass_weight;
        var adipose_tissue_mass_percent;
        var adipose_tissue_mass_weight;
        var bmi;

        for(var key in formData) {
            var formData2 = formData[key];
            for(var key2 in formData2) {
                var data = formData2[key2];

                if(key2 === "height" && this.isObject(data) == false) {
                    height = data;
                } else if(key2 === "weight" && this.isObject(data) == false) {
                    weight = data;
                } else if(key2 === "lean_tissue_mass_percent" && this.isObject(data) == false) {
                    lean_tissue_mass_percent = data;
                } else if(key2 === "lean_tissue_mass_weight" && this.isObject(data) == false) {
                    lean_tissue_mass_weight = data;
                } else if(key2 === "adipose_tissue_mass_percent" && this.isObject(data) == false) {
                    adipose_tissue_mass_percent = data;
                } else if(key2 === "adipose_tissue_mass_weight" && this.isObject(data) == false) {
                    adipose_tissue_mass_weight = data;
                } else if(key2 === "bmi" && this.isObject(data) == false) {
                    bmi = data;
                }
            }
        }

        var obj = {};
        obj.height                      = height;
        obj.weight                      = weight;
        obj.lean_tissue_mass_percent    = lean_tissue_mass_percent;
        obj.lean_tissue_mass_weight     = lean_tissue_mass_weight;
        obj.adipose_tissue_mass_percent = adipose_tissue_mass_percent;
        obj.adipose_tissue_mass_weight  = adipose_tissue_mass_weight;
        obj.bmi                         = bmi;

        return obj;
    }

    onChange = (formData) => {
        var obj = this.getObjectData(formData);

        var height                      = obj.height;
        var weight                      = obj.weight;
        var lean_tissue_mass_percent    = obj.lean_tissue_mass_percent;
        var lean_tissue_mass_weight     = obj.lean_tissue_mass_weight;
        var adipose_tissue_mass_percent = obj.adipose_tissue_mass_percent;
        var adipose_tissue_mass_weight  = obj.adipose_tissue_mass_weight;
        var bmi                         = obj.bmi;

        this.setUserFormData(height, weight, lean_tissue_mass_percent, lean_tissue_mass_weight,adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi);
    }

    render() {

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
             </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/BodyCompForm.js